import { FiscalNumber } from "../fiscal-number";
import { MonitorStatus } from "./monitor-status";
import { ProductItem } from "./product-item";
import { ShippingType } from "./shipping-type.enum";

export class TransactionalManagementSale {
  private id: string;
  private uniqueSequencialNumber: string;
  private type: string;
  private beneficiarySocialNumber: string;
  private beneficiaryName: string;
  private isHolder: boolean;
  private cardNumber: string;
  private networkFiscalNumber: FiscalNumber;
  private totalPrice: number;
  private totalCardValue: number;
  private totalCheckoutValue: number;
  private transactionDate: string;
  private monitorStatus: MonitorStatus;
  private shippingType: ShippingType;
  private productItems: ProductItem[];
  private uniqueSequencialNumberCorrelated: string;

  constructor() {
    this.productItems = [];
  }
  
  public getId(): string {
    return this.id;
  }

  public setId(value: string): void {
    this.id = value;
  }

  public getUniqueSequencialNumber(): string {
    return this.uniqueSequencialNumber;
  }

  public setUniqueSequencialNumber(value: string): void {
    this.uniqueSequencialNumber = value;
  }

  public getType(): string {
    return this.type;
  }

  public setType(value: string): void {
    this.type = value;
  }

  public getBeneficiarySocialNumber(): string {
    return this.beneficiarySocialNumber;
  }

  public setBeneficiarySocialNumber(value: string): void {
    this.beneficiarySocialNumber = value;
  }

  public getShippingType(): ShippingType {
    return this.shippingType;
  }

  public setShippingType(value: ShippingType): void {
    this.shippingType = value;
  }

  public getBeneficiaryName(): string {
    return this.beneficiaryName;
  }

  public setBeneficiaryName(value: string): void {
    this.beneficiaryName = value;
  }

  public getIsHolder(): boolean {
    return this.isHolder;
  }

  public setIsHolder(value: boolean): void {
    this.isHolder = value;
  }

  public getCardNumber(): string {
    return this.cardNumber;
  }

  public setCardNumber(value: string): void {
    this.cardNumber = value;
  }

  public getNetworkFiscalNumber(): FiscalNumber {
    return this.networkFiscalNumber;
  }

  public setNetworkFiscalNumber(value: FiscalNumber): void {
    this.networkFiscalNumber = value;
  }

  public getTotalPrice(): number {
    return this.totalPrice;
  }

  public setTotalPrice(value: number): void {
    this.totalPrice = value;
  }

  public getTotalCardValue(): number {
    return this.totalCardValue;
  }

  public setTotalCardValue(value: number): void {
    this.totalCardValue = value;
  }

  public getTotalCheckoutValue(): number {
    return this.totalCheckoutValue;
  }

  public setTotalCheckoutValue(value: number): void {
    this.totalCheckoutValue = value;
  }

  public getTransactionDate(): string {
    return this.transactionDate;
  }

  public setTransactionDate(value: string): void {
    const year = value.slice(0, 4);
    const month = value.slice(5, 7);
    const day = value.slice(8, 10);
    const hour = value.slice(11, 16);
    this.transactionDate = `${day}/${month}/${year} - ${hour}`;
  }

  public getMonitorStatus(): MonitorStatus {
    return this.monitorStatus;
  }

  public setMonitorStatus(value: number): void {
    this.monitorStatus = MonitorStatus.fromEnum(value);
  }

  public getProductItems(): ProductItem[] {
    return this.productItems;
  }

  public setProductItems(value: ProductItem[]): void {
    this.productItems = value;
  }

  public getUniqueSequencialNumberCorrelated(): string {
    return this.uniqueSequencialNumberCorrelated;
  }

  public setUniqueSequencialNumberCorrelated(uniqueSequencialNumberCorrelated: string): void {
    this.uniqueSequencialNumberCorrelated = uniqueSequencialNumberCorrelated;
  }
}
